import VueMq from 'vue-mq'

import GlobalComponents from './GlobalComponents'
import Icons from './Icons'
import { HTTP, UNSAFE_API_GET, API_GET, API_POST, SAFE_API_GET } from '@/utils/http'

import '@/assets/scss/style.scss'

export default {
  install (Vue) {
    Vue.prototype.$HTTP = HTTP
    Vue.prototype.$UNSAFE_API_GET = UNSAFE_API_GET
    Vue.prototype.$API_GET = API_GET
    Vue.prototype.$SAFE_API_GET = SAFE_API_GET
    Vue.prototype.$API_POST = API_POST
    Vue.prototype.$LEFT_COL = 'col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12'
    Vue.prototype.$RIGHT_COL = 'col-xl-4 col-lg-4 col-md-4 col-sm-4'
    Vue.prototype.$ALERT_COL = 'col-xl-8 col-lg-9'

    Vue.use(Icons)
    Vue.use(GlobalComponents)
    Vue.use(VueMq, {
      breakpoints: {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200
      }
    })
  }
}
